// extracted by mini-css-extract-plugin
var _1 = "src-components-EditNotePage-_ModalRedirectDialog__dialogText--aeVy1ybJxMUhpy87lLso";
var _2 = "src-components-EditNotePage-_ModalRedirectDialog__modalRedirectDialog--IOfJWDjTuTITFmpzMnag";
export { _1 as "dialogText", _2 as "modalRedirectDialog" }
